module.exports = __webpack_public_path__ + "img/cierre.9835fd93.jpg";